import axios from "axios";
//const API_URL = "http://localhost:3001/v1/auth/";
const API_URL = `${process.env.REACT_APP_API_HOST}/v1/auth/`;

const MFA_TOKEN_KEY = "mfaToken";

class AuthService {
  // Step 1: verify password. Returns { mfaToken, mfaSetupRequired } — NO tokens yet.
  login(username, password) {
    return axios
      .post(API_URL + "login", {
        email: username,
        password: password
      })
      .then(response => {
        const data = response.data;
        if (data.tokens) {
          // MFA disabled globally — fully authenticated already, persist the session.
          this._persistSession(data);
        } else if (data.mfaToken) {
          sessionStorage.setItem(MFA_TOKEN_KEY, data.mfaToken);
        }
        return data;
      });
  }

  getMfaToken() {
    return sessionStorage.getItem(MFA_TOKEN_KEY);
  }

  clearMfaToken() {
    sessionStorage.removeItem(MFA_TOKEN_KEY);
  }

  // Step 2a (new user): fetch the QR / secret to scan.
  setupMfa() {
    return axios
      .post(API_URL + "mfa/setup", { mfaToken: this.getMfaToken() })
      .then(response => response.data);
  }

  // Step 2b (new user): confirm two consecutive codes; persists the session on success.
  verifyMfaSetup(setupToken, otp1, otp2) {
    return axios
      .post(API_URL + "mfa/setup/verify", { setupToken, otp1, otp2 })
      .then(response => {
        this._persistSession(response.data);
        return response.data;
      });
  }

  // Step 2 (returning user): confirm one code; persists the session on success.
  verifyMfaLogin(otp) {
    return axios
      .post(API_URL + "mfa/verify", { mfaToken: this.getMfaToken(), otp })
      .then(response => {
        this._persistSession(response.data);
        return response.data;
      });
  }

  // Store the authenticated session exactly as the old login flow did.
  _persistSession(data) {
    if (data && data.tokens && data.tokens.access && data.tokens.access.token) {
      localStorage.setItem("user", JSON.stringify({ user: data.user, tokens: data.tokens }));
      localStorage.setItem("preferences", JSON.stringify(data.preferences));
      localStorage.setItem("properties", JSON.stringify(data.properties));
      localStorage.setItem("sidebar", true);
      this.clearMfaToken();
    }
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("preferences");
    localStorage.removeItem("properties");
    localStorage.removeItem("sidebar");
    this.clearMfaToken();
  }

  register(username, email, password) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  // True if the logged-in user holds the given permission (e.g. 'manageRules').
  hasPermission(perm) {
    const cu = this.getCurrentUser();
    return !!(cu && cu.user && Array.isArray(cu.user.permissions) && cu.user.permissions.includes(perm));
  }

  clearToken() {
    if (localStorage.getItem("user")) {
      localStorage.removeItem("user");
      localStorage.removeItem("preferences");
      localStorage.removeItem("properties");
      localStorage.removeItem("sidebar");
    }
    this.clearMfaToken();
    return;
  }
}

export default new AuthService();
